import { render } from "./ContragentsChooser.vue?vue&type=template&id=4c876530"
import script from "./ContragentsChooser.vue?vue&type=script&lang=js"
export * from "./ContragentsChooser.vue?vue&type=script&lang=js"
script.render = render

export default script